<income [contactId]="contactId"></income>
<identifications [contactId]="contactId" [isFlat]="false"></identifications>
<references [contactId]="contactId"></references>
<personal-auto-insurance [contactId]="contactId"></personal-auto-insurance>
<div class="text-right">
    <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    <!-- <button class="btn btn-sm btn-success" (click)="reactivateRole()">Reactivate Role</button> -->
</div>
